import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const fetchServiceRepair = createAction(types.FETCH_SERVICE_REPAIR);
export const fetchServiceRepairSuccess = createAction(types.FETCH_SERVICE_REPAIR_SUCCESS);
export const fetchServiceRepairFailure = createAction(types.FETCH_SERVICE_REPAIR_FAILURE);

